import { Menu, MenuItem, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
const StatusMenu = styled(Menu)`
  .MuiMenu-list {
    padding: 0;
    outline: none;
  }
`;
const StatusOptions = styled(MenuItem)`
  &&.MuiMenuItem-root {
    padding: 6px 8px;
    display: flex;
    outline: none;
    border-radius: 4px;
    font-size: 10px;
    font-weight: 700;
    line-height: 12px;
    letter-spacing: 0.5px;
    text-transform: uppercase;
    align-items: center;
    height: 24px;
  }
`;
const OptionText = styled(Typography)`
  display: flex;
  font-size: 10px;
  font-weight: 700;
  line-height: 12px;
  letter-spacing: 0.5px;
  text-transform: uppercase;
`;
export {
  OptionText,
  StatusMenu,
  StatusOptions
};
